import React, { Component } from 'react';

import MainButton from './shared/MainButton';

export default class ViewSpec extends Component {
  render() {
    return (
      <div>
        <div style={{ marginLeft: 'auto', marginRight: 'auto', width: 832 }}>
          <iframe
            title="blueshyft ad specifications"
            src="https://docs.google.com/document/d/e/2PACX-1vSSJu7yrCxNaB1xtBGWP3Ct-msIe46Ot8B9MGYenK7CM8Xe7AzyL2WRV9mOZ2u-TNug-JHtb7QBkyiz/pub?embedded=true"
            style={{
              border: '2px solid #e2e5ef',
              width: 830,
              height: 1000,
              borderRadius: 5,
            }}
          />
          <MainButton
            as="a"
            target="_blank"
            href="https://s3-ap-southeast-2.amazonaws.com/bsau-assets/docs/pdfs/Marketing+Platform+Ad+Specifications.pdf"
            style={{
              width: 818, height: 50, backgroundColor: '#7392ee', color: 'white', marginTop: 25, marginBottom: 25, textDecoration: 'none',
            }}
          >
            DOWNLOAD AS PDF
          </MainButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/ViewSpec.js